import * as R from 'remeda';
import {
  isSchemaSimpleMultiValue,
  isSchemaTableMultiValue,
  SchemaItem,
  SchemaSection,
  SchemaSimpleMultivalue,
  SchemaTableMultivalue,
} from '@rossum/api-client/schemas';

// we should change the ID of the multivalue only when the child ID has changed
const idsHaveChanged =
  (originalItem: SchemaSection | SchemaItem | null) =>
  (simpleMultivalue: SchemaSimpleMultivalue) => {
    const originalId = isSchemaSimpleMultiValue(originalItem)
      ? originalItem.children.id
      : null;

    return simpleMultivalue.children.id !== originalId;
  };

const setMultivalueId = (
  simpleMultivalue: SchemaSimpleMultivalue
): SchemaSimpleMultivalue => ({
  ...simpleMultivalue,
  id: `${simpleMultivalue.children.id}_multi`,
});

const hasOriginalId = (originalId: string | undefined) => !!originalId;
const setOriginalId =
  (originalId: string) => (multivalueDatapoint: SchemaSimpleMultivalue) =>
    R.setPath(multivalueDatapoint, ['id'], originalId);

const setTupleId =
  (originalItem: SchemaSection | SchemaItem | null) =>
  (tableMultivalue: SchemaTableMultivalue): SchemaTableMultivalue =>
    // do not overwrite existing tuple ID
    isSchemaTableMultiValue(originalItem) && originalItem.children.id
      ? tableMultivalue
      : R.setPath(
          tableMultivalue,
          ['children', 'id'],
          `${tableMultivalue.id}_tuple`
        );

export const adjustIds =
  (originalItem: SchemaSection | SchemaItem | null) =>
  <T>(obj: T): T => {
    const originalId = originalItem?.id;
    if (isSchemaSimpleMultiValue(obj)) {
      if (idsHaveChanged(originalItem)(obj)) {
        return setMultivalueId(obj) as T;
      }
      if (hasOriginalId(originalId)) {
        return setOriginalId(originalId!)(obj) as T;
      }
    }

    if (isSchemaTableMultiValue(obj)) {
      return setTupleId(originalItem)(obj) as T;
    }

    return obj;
  };
